import React from 'react';
import {Container, Typography, Box} from '@mui/material';
import SectionTitle from "./SectionTitle";

function AboutMe() {
    return (
        <Container sx={{ padding: '64px 0', overflow: 'hidden'}}>
            <SectionTitle title={'About Me'} />
            <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', gap: '32px' }}>
                <Typography variant="p" fontSize={'larger'}>
                    I am a <strong>Product Designer</strong> with over four years of experience, specializing in creating intuitive and engaging products.
                </Typography>
                <Typography variant="p" fontSize={'larger'}>
                    I have led design projects from conception to realization, collaborating with multidisciplinary teams to translate user needs into innovative digital solutions.
                </Typography>
                <Typography variant="p" fontSize={'larger'}>
                    I have worked in a dynamic international company, supporting the team with the creation of a Global Design System. This experience has refined my design skills and deepened my understanding of the global market and the cultural nuances in design strategy.
                </Typography>
                <Typography variant="p" fontSize={'larger'}>
                    Searching for a designer that shows passion in their work? Interested in working together? I'd love to hear from you!
                </Typography>
            </Box>
        </Container>
    );
}

export default AboutMe;